import { render, staticRenderFns } from "./FormsGrid.vue?vue&type=template&id=3c023d36"
import script from "./FormsGrid.vue?vue&type=script&lang=js"
export * from "./FormsGrid.vue?vue&type=script&lang=js"
import style0 from "./FormsGrid.vue?vue&type=style&index=0&id=3c023d36&prod&lang=css"
import style1 from "./FormsGrid.vue?vue&type=style&index=1&id=3c023d36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports